import Security from "./security";

export default Security;
